import {Action, ActionReducer, createReducer, on} from "@ngrx/store";
import { NotificationsState } from "./notificationCenter";
import {
  deleteInfoNotifications, deleteInfoNotificationsSuccess,
  loadNotificationCenter,
  loadNotificationCenterSuccess
} from "./notificationCenter.actions";
import {Serializer} from "../../interfaces/serializer";
import {NotificationComponentObject} from "../../classes/notification-component-object";
import {Notification} from "../../interfaces/notification";
import {notificationMarkAsRead} from "../../components/notifications/notification.actions";

const reducer: ActionReducer<NotificationsState> = createReducer(
  {notifications: [], loading: false, loaded: false } as NotificationsState,
  on(loadNotificationCenter, (state: NotificationsState) => {
    return { notifications: state.notifications, loading: true, loaded: false };
  }),
  on(loadNotificationCenterSuccess, (state: NotificationsState, action) => {
    return {
      notifications: action.notifications.map((notification: Serializer<Notification>): NotificationComponentObject => new NotificationComponentObject(notification)),
      loading: false,
      loaded: true
    };
  }),
  on(deleteInfoNotifications, (state: NotificationsState) => {
    return { notifications: state.notifications, loading: true, loaded: false };
  }),
  on(deleteInfoNotificationsSuccess, (state: NotificationsState, action) => {
    return {
      notifications: action.notifications.map((notification: Serializer<Notification>): NotificationComponentObject => new NotificationComponentObject(notification)),
      loading: false,
      loaded: true
    };
  }),
  on(notificationMarkAsRead, (state: NotificationsState, action) => {
    return {
      ...state,
      notifications: state.notifications.filter((notification: NotificationComponentObject): boolean => notification.payload.id !== action.notification.id)
    };
  })
);

export const notificationCenterReducer: ActionReducer<NotificationsState> = (state: NotificationsState, action: Action) => {
  return reducer(state, action);
};
